import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    EmailField,
    BooleanField,
    EditButton,
    SavedQueriesList,
    FilterLiveSearch,
    FilterList,
    FilterListItem,
} from 'react-admin';
import { Card, CardContent } from '@mui/material';
import MailIcon from '@mui/icons-material/MailOutline';
import { Check } from '@mui/icons-material';
import StandardListActions from './StandardListActions';
import { COUNTRIES, LANGUAGES, USER_TYPES, USER_SUBTYPES } from '../choices';
import { ListFilterSelect } from './filters/ListFilterSelect';

export const UsersFilterSidebar = () => (
    <Card sx={{ order: -1, mr: 2, mt: 6, width: 'max-content' }}>
        <CardContent>
            <SavedQueriesList />

            <FilterLiveSearch label='Email' source='email__ilike' variant='outlined' />
            <FilterLiveSearch label='Username' source='username__ilike' variant='outlined' />
            <FilterLiveSearch label='First Name' source='first_name__ilike' variant='outlined' />
            <FilterLiveSearch label='Last Name' source='last_name__ilike' variant='outlined' />
            <ListFilterSelect source='type' label='Type' choices={USER_TYPES} />
            <ListFilterSelect source='subtype' label='Subtype' choices={USER_SUBTYPES} />
            <ListFilterSelect source='country' label='Country' choices={COUNTRIES} />
            <ListFilterSelect source='language' label='Language' choices={LANGUAGES} />
            <FilterList label='Validated Type' icon={<Check />}>
                <FilterListItem label='Yes' value={{ validated_type: true }} />
                <FilterListItem label='No' value={{ validated_type: false }} />
            </FilterList>
            <FilterList label='Verified Email' icon={<MailIcon />}>
                <FilterListItem label='Yes' value={{ verified_email: true }} />
                <FilterListItem label='No' value={{ verified_email: false }} />
            </FilterList>
        </CardContent>
    </Card>
);

const UsersList = (props: any) => {
    return (
        <List {...props} aside={<UsersFilterSidebar />} actions={<StandardListActions />}>
            <Datagrid rowClick='edit'>
                <TextField source='id' />
                <TextField source='username' />
                <EmailField source='email' />
                <BooleanField source='validated_type' />
                <TextField source='type' />
                <TextField source='subtype' />
                <TextField source='first_name' />
                <TextField source='last_name' />
                <TextField source='country' />
                <TextField source='language' />
                <TextField source='phone' />
                <BooleanField source='verified_email' />
                <TextField source='date_joined' />
                <TextField source='last_login' />
                <EditButton />
            </Datagrid>
        </List>
    );
};

export default UsersList;
